let isPreviewLogoShow = localStorage
    .getItem('previewLogoShow') ? localStorage.getItem('previewLogoShow') : false;

let isPreviewAnimationFinished = false;

let $svg = $('.j-animate-cube').drawsvg({
    stagger: 400
});

window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};

$(window).on('beforeunload', function () {
    $(window).scrollTop(0);
});

$(document).bind('scroll', function () {
    let scrollOffset = $(document).scrollTop();
    let containerOffset = $('.description-cards-list').offset().top - window.innerHeight;
    if (scrollOffset > containerOffset) {
        $('.description-cards-list').addClass('start-animation')
        $(document).unbind('scroll');
    }
});

$(document).ready(function () {
    let $doc = $(document),
        $win = $(window),
        max = $doc.height() - $win.height();
    $(this).scrollTop(0);

    $('.mobile-nav-btn').click(function () {
        $('.mobile-nav').addClass('active')
    });

    $('.close-btn').click(function () {
        $('.mobile-nav').removeClass('active')
    });

    $('.j-light-mode').click(function () {
        $('html').toggleClass('light-theme');
    });

    $('.j-about-anchor-link').click(function () {
        animationLogoStepDeactivate();
    });

    $('.j-feature-anchor-link').click(function () {
        animationLogoStepActivate();
    });

    if (isPreviewAnimationFinished) {
        $('.j-preview-animation-wrapper').addClass('preview-animation-finished');
        $('.j-about-content').find('p').addClass('show');
        $('.j-about-content').addClass('j-about-content-show');
        $('.about-footer').addClass('about-footer-mobile-hide');
        $('.j-header-logo').addClass('header-logo-show');
        $('.j-about').addClass('about-static');
        $('.j-about').addClass('about-fade-in');
        $('.j-about-list li').addClass('active');
    }

    setTimeout(() => {
        $('.j-preview-block').removeClass('loader');
    }, 75);

    if (isPreviewLogoShow) {
        $('.preview-logo-wrapper').addClass('no-logo-animation');
        $('.preview-content').addClass('no-preview-animation');
        let $doc = $(document),
            $win = $(window),
            speed = 600,
            max = $doc.height() - $win.height() - speed;

        drawSvgAnimation($win, max);
        return;
    }

    $('html, body').addClass('disable-scroll');

    setTimeout(() => {
        $('html, body').removeClass('disable-scroll')
    }, 7000);

    drawSvgAnimation($win, max);
});

$(window).scroll(function () {
    const scroll = $(window).scrollTop();
    const previewBlockHeight = $('.j-preview-block').innerHeight();
    const speed = 1000;
    const marketplaceOpacity = (scroll - previewBlockHeight) / speed;
    // const logoFixedScrollValue = $(window).height() >= 2160 ? 1170 : 720;

    let logoFixedScrollValue;

    if ($(window).height() >= 2160) {
        logoFixedScrollValue = 1370;
    } else if ($(window).height() >= 1440 && $(window).height() < 2160) {
        logoFixedScrollValue = 900;
    } else if ($(window).height() >= 1080 && $(window).height() < 1440) {
        logoFixedScrollValue = 620;
    } else if ($(window).height() >= 1024 && $(window).height() < 1049) {
        logoFixedScrollValue = 540;
    } else {
        logoFixedScrollValue = 620;
    }

    let policyOpacity = 0;
    let coverageOpacity = 0;

    if (window.matchMedia("(max-width: 660px)").matches) {
        if (scroll > 2) {
            $('.preview-content').fadeOut();
        }
    }

    if ((previewBlockHeight - scroll) <= logoFixedScrollValue) {
        $(".j-logo").addClass('j-fixed hide-network');
    } else {
        $(".j-logo").removeClass('j-fixed');
    }

    if (previewBlockHeight <= scroll + 20 && !isPreviewAnimationFinished) {
        $('.header-bg').addClass('active');
    } else {
        $('.header-bg').removeClass('active');
    }

    if (isPreviewAnimationFinished) {
        $('.header-bg').addClass('active');
        const logoHeight = document.getElementById('logo-id').offsetHeight;
        const logoToTop = document.getElementById('logo-id').getBoundingClientRect().top + logoHeight + 60;
        const aboutToTop = document.getElementById('about-id').getBoundingClientRect().top

        if (logoToTop >= aboutToTop) {
            $(".j-logo").css({
                'opacity': 0
            });

            $('.scrollable-logo').show();
        } else {
            $(".j-logo").css({
                'opacity': 1
            });

            $('.scrollable-logo').hide();
        }
    }

    if ((previewBlockHeight >= 1100 ? previewBlockHeight : previewBlockHeight - 100) <= scroll) {
        $('.j-about').addClass('about-fade-in');
        $('.j-about-content').addClass('j-about-content-show');
        $('.j-about-list li:nth-child(1)').addClass('active');
        if (isPreviewAnimationFinished) {
            animationLogoStepActivate();
            $('.j-marketplace-animation').css({
                'opacity': 1
            });
            return;
        }
        $('.j-marketplace-animation').css({
            'opacity': marketplaceOpacity
        });
    } else if (!isPreviewAnimationFinished) {
        $('.j-about').removeClass('about-fade-in');
        $('.j-about-content').removeClass('j-about-content-show');
        $('.j-about-list li:nth-child(1)').removeClass('active');
        // $('.header-bg').removeClass('active');
    } else if (isPreviewAnimationFinished) {
        animationLogoStepDeactivate();
        // $('.header-bg').removeClass('active');
    }

    if (marketplaceOpacity >= 1 && !isPreviewAnimationFinished) {
        policyOpacity = marketplaceOpacity - 1
        $('.j-policy-animation').css({
            'opacity': policyOpacity
        });
        $('.j-about-list li:nth-child(2)').addClass('active');
    } else if (!isPreviewAnimationFinished) {
        $('.j-about-list li:nth-child(2)').removeClass('active');
    }

    if (policyOpacity >= 1 && !isPreviewAnimationFinished) {
        coverageOpacity = policyOpacity - 1
        $('.j-coverage-animation').css({
            'opacity': coverageOpacity
        });
        $('.j-about-list li:nth-child(3)').addClass('active');
    } else if (!isPreviewAnimationFinished) {
        $('.j-about-list li:nth-child(3)').removeClass('active');
    }
    if (coverageOpacity >= 1 && !isPreviewAnimationFinished) {
        animationLogoStepActivate();
        window.scrollTo(0, previewBlockHeight);
        $('.j-preview-animation-wrapper').addClass('preview-animation-finished');
        $('.j-animate-cube').hide();
        $('.static-animation-cube').show();
        isPreviewAnimationFinished = true;
        localStorage.setItem('previewLogoShow', isPreviewAnimationFinished);
    } else if (!isPreviewAnimationFinished) {
        animationLogoStepDeactivate();
    }
});

function animationLogoStepActivate() {
    //$('.j-about-content').hide();
    $('.about-footer').addClass('about-footer-mobile-hide');
    /*    $(".j-logo").css({
            'opacity': 0
        });*/
    $('.j-about-description').addClass('about-description-show');
    $('.j-header-logo').addClass('header-logo-show');
    $('.j-about').addClass('about-static');
    $('.j-about-list li').addClass('active');
    $('.j-feature-anchor-link').addClass('active');
    $('.j-about-anchor-link').removeClass('active');
}

function animationLogoStepDeactivate() {
    $('.j-about-description').removeClass('about-description-show');
    $('.j-header-logo').removeClass('header-logo-show');
    // $('.j-about').removeClass('about-static');
    $('.j-about-content').show();
    /*  $(".j-logo").css({
          'opacity': 1
      });*/

    $('.j-about-anchor-link').addClass('active');
    $('.j-feature-anchor-link').removeClass('active');
}

function drawSvgAnimation(win, max) {
    win.on('scroll', function () {
        $svg.drawsvg('progress', win.scrollTop() / max);
    });
}
